Calendar.$inject = ['Time', '$window', '_'];

/* @ngInject */
function Calendar(Time, $window, _) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
        template: require('../../views/booking/calendar.directive.html'),
        restrict: 'E',
        scope: {
            start: '=start',
            end: '=end',
            currentDate: '=currentDate',
            schedule: '=schedule',
            rowHeight: '@rowHeight',
            slotSizeInMinutes: '=',
            onCreateClick: '=onCreateClick',
            onEventClick: '=onEventClick',
        },
        bindToController: true,
        controller: CalendarController,
        controllerAs: 'vm',
        link: link,
    };
    return directive;

    function link($scope, element, attrs) {
        var vm = $scope.vm,
            calendarElement = element.find('.calendar'),
            timelineElement = element.find('.timeline'),
            rowHeight = vm.getRowHeight();

        // Methods

        //////////////////////

        function activate() {
            vm.buildTimes();
            setCalendarHeight();

            Livetime.update();
            WidthCalculator.calculate();

            setupListeners();
            $scope.$on('$destroy', removeListeners);
        }

        /**
         * Calculate view height
         * @method setHeight
         */
        function setCalendarHeight() {
            var rows = vm.times.length + 2;
            var baseHeight = 18;
            element.css({
                height: (rows * rowHeight + baseHeight) + 'px'
            });
        }

        /**
         * Calculates the ammout of rows that fit on the screen
         * Updates the vm.rows
         *
         * @class WidthCalculator
         * @type {Object}
         */
        var WidthCalculator = {
            calculate: _.debounce(function () {
                var width = calendarElement.width(),
                    offset = width < 425 ? WidthCalculator.offset : WidthCalculator.offset_max,
                    cols = (width - offset) / WidthCalculator.column;
                vm.cols = parseInt(cols);
                vm.$scope.$digest();
            }, 50),
            offset: 20,
            offset_max: 100,
            column: 210,
            install: function (window) {
                window.bind('resize', WidthCalculator.calculate);
            },
            uninstall: function (window) {
                window.unbind('resize', WidthCalculator.calculate);
            }
        };

        /**
         * Livetime singleton
         * @class Livetime
         * @type {Object}
         */
        var Livetime = {
            element: element.find('hr.livetime'),
            updateInterval: null,
            max: (function () {
                var end = new Time.Hour().fromFloat(parseFloat(vm.end) + 0.5);
                return vm.calOffset(end);
            })(),
            start: new Time.Hour().fromFloat(vm.start),
            update: function () {
                var now = new Time.Hour().fromDate(new Date()),
                    top = now.gt(Livetime.start) ? vm.calOffset(now) : 0;

                Livetime.element.css({
                    top: Math.min(Livetime.max, top) + 'px'
                });
            },
            install: function () {
                Livetime.updateInterval = setInterval(Livetime.update, 5 * 60 * 1000);
            },
            uninstall: function () {
                clearInterval(Livetime.updateInterval);
                Livetime.updateInterval = null;
            }
        };


        /**
         * Handles row selection (show the active row)
         * Singleton
         * @class RowSelected
         * @type {Object}
         */
        var RowSelected = {
            /**
             * Saves the lastActive hour
             * @type {Float}
             */
            lastActive: null,
            /**
             * Install event listeners and set variables
             * @method install
             * @param  {jQuery Element} el
             */
            install: function (el) {
                el.on('mouseleave', '.events-group', RowSelected.unselectActive);
                el.on('mousemove', '.events-group', RowSelected.mousemove);
            },
            /**
             * Removes the event listeners
             * @method uninstall
             * @param  {jQuery Element} el
             */
            uninstall: function (el) {
                el.off('mouseleave');
                el.off('mousemove');
            },
            /**
             * Clears the active class from the active element
             * @method unselectActive
             */
            unselectActive: function () {
                RowSelected.lastActive = null;
                timelineElement.find('li.active').removeClass('active');
            },
            /**
             * Sets the active (if not the same as lastActive)
             * @method setActive
             * @param  {Number} height Height position of mouse to calculate current
             */
            setActive: function (height) {
                var hour = vm.calHour(height);
                if (RowSelected.lastActive !== hour) {
                    RowSelected.unselectActive();
                    RowSelected.lastActive = hour;
                    timelineElement
                        .find('li#time-' + Time.floatToID(hour))
                        .addClass('active');
                }
            },
            /**
             * Mouse move event
             * @method
             */
            mousemove: _.debounce(function (e) {
                if (e.target.nodeName !== 'UL') {
                    RowSelected.unselectActive();
                    return;
                }
                RowSelected.setActive(e.offsetY);
            }, 1)
        };

        /**
         * Handle creation of events
         * @type {Object}
         */
        var CreateHandler = {

            install: function (el) {
                el.on('click', '.events-group ul', CreateHandler.gridClick);
            },
            uninstall: function (el) {
                el.off('click');
            },

            gridClick: function (e) {
                if (e.target.nodeName !== 'UL') {
                    return;
                }

                var column = angular.element(this).scope().column,
                    hour = vm.calHour(e.offsetY);
                if (vm.onCreateClick) {
                    vm.onCreateClick(hour, column);
                }
            }
        };

        /**
         * Set up event listeners
         * @method setupListeners
         */
        function setupListeners() {
            WidthCalculator.install(angular.element($window));
            Livetime.install();
            CreateHandler.install(element);
            RowSelected.install(element);
        }

        function removeListeners() {
            WidthCalculator.uninstall(angular.element($window));
            CreateHandler.uninstall(element);
            Livetime.uninstall();
            RowSelected.uninstall(element);
        }

        activate();
    }
}

/* @ngInject */
CalendarController.$inject = ['$scope', 'Time', '_'];

function CalendarController($scope, Time, _) {
    var vm = this;
    this.$scope = $scope;
    // Dependencies
    this.$injected = {
        Time: Time,
        _: _
    };

    // Construct variables
    vm.times = [];
    vm.selected = null;
    vm.cols = 1;
    vm.nav = {
        cursor: 0,
        hasNext: true,
        hasPrev: true,
        next: function () {
            if (this.nav.hasNext) {
                this.nav.cursor = Math.min(this.nav.cursor + vm.cols, this.schedule.length);
            }
        }.bind(this),
        prev: function () {
            if (this.nav.hasPrev) {
                this.nav.cursor = Math.max(this.nav.cursor - vm.cols, 0);
            }
        }.bind(this)
    };
    vm.events = [];

    // Set up listeners
    $scope.$watch('vm.schedule', function (now, before) {
        if (now.length !== before.length) {
            this.reevaluateNavigation(this.nav.cursor);
            this.refreshSchedule();
        }
    }.bind(this));
    $scope.$watch('vm.cols', function (now, before) {
        if (now !== before) {
            this.reevaluateNavigation(this.nav.cursor);
            this.refreshCols();
        }
    }.bind(this));
    $scope.$watch('vm.nav.cursor', function (cursor, old) {
        this.reevaluateNavigation(cursor, old);
    }.bind(this));
}

CalendarController.prototype.reevaluateNavigation = function (cursor, old) {
    // Reevaluate next & prev
    this.nav.hasPrev = cursor > 0;
    this.nav.hasNext = (cursor + this.cols) < (this.schedule.length);
    if (cursor !== old) {
        this.refreshSchedule();
    }
};
CalendarController.prototype.refreshCols = function () {
    if (this.cols) {
        this.refreshSchedule();
    }
};
CalendarController.prototype.refreshSchedule = function () {
    this.events = this.schedule.slice(this.nav.cursor, parseInt(this.nav.cursor) + this.cols);
};

CalendarController.prototype.getRowHeight = function () {
    // keep default value in sync with $calendar-row-height@_variables.scss
    if(!this.rowHeight) {
        const slotsPerHour = 60 / this.slotSizeInMinutes;
        this.rowHeight = Math.max(30, 90 / slotsPerHour);
    }
    return this.rowHeight || 45;
};

CalendarController.prototype.getIsFirstChildColumn = function (id) {
    const firstChildColumn = document.querySelector("#court-columns").firstElementChild

    return +firstChildColumn.id === +id
    
}

/**
 * Calculates the hour given the Y offset
 * @method calHour
 * @param  {Number} offset
 * @return {Number} hour
 */
CalendarController.prototype.calHour = function (offset) {
    const intervals = Math.floor(offset / this.getRowHeight());
    return this.start + intervals * (this.slotSizeInMinutes / 60);
};
/**
 * Calculates the Y offset given the hour
 * @method calOffset
 * @return {Number} hour
 */
CalendarController.prototype.calOffset = function (hour) {
    const Time = this.$injected.Time;
    const start = new Time.Hour().fromFloat(this.start);
    const sub = hour.subtract(start);
    const slotsPerHour = 60 / this.slotSizeInMinutes;
    return sub * slotsPerHour * this.getRowHeight();
};
/**
 * Builds the times attribute with every hour on the list
 * @method buildTimes
 */
CalendarController.prototype.buildTimes = function () {
    var Time = this.$injected.Time;
    var times = [];
    var it = 0,
        cursor = new Time.Hour(),
        next = new Time.Hour();
    var start = parseFloat(this.start),
        end = parseFloat(this.end);

    const inc = this.slotSizeInMinutes / 60;

    for (var i = start; i < end; i += inc) {
        it = i % 24;
        cursor.fromFloat(i);
        next.fromFloat((it + inc) % 24);
        times.push({
            isHour: i.toFixed(5).endsWith(".00000"),
            id: Time.floatToID(i),
            start: cursor.toStringFormalized(),
            end: next.toStringFormalized()
        });
    }

    this.times = times;
    return this.times;
};

export default Calendar;
